"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'parade',
    name: 'Parade',
    background_color: '#7de2f9',
    background_image: 'https://assets.raydiant.com/images/parade.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/parade-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Lobster-Regular.woff',
    heading_text_color: '#191919',
    heading_2_font: 'https://fonts.raydiant.com/Cabin-Bold.woff',
    heading_2_text_color: '#051727',
    body_font: 'https://fonts.raydiant.com/Cabin-Regular.woff',
    body_text_color: '#051727',
    border_color: '#000000',
};
//# sourceMappingURL=parade.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/parade.js